"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _Document = _interopRequireDefault(require("./Document.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ReactFile01 = (0, _component.default)(function () {
  return import("@micado-digital/react-file/ReactFile01");
});
var Document = function Document(_ref) {
  var _ref$media = _ref.media,
    media = _ref$media === void 0 ? {} : _ref$media;
  var title = media.title;
  var css = (0, _Document.default)();
  if ((0, _isEmpty.default)(media)) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.document, "mco-shop-myaccount-digital-product-details-document")
  }, /*#__PURE__*/_react.default.createElement(ReactFile01, {
    media: [media],
    target: "_blank",
    title: title
  }));
};
var _default = Document;
exports.default = _default;